// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/wind-indicators.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/wind-indicators/wind-indicators.js';

mount([g0]);
